import React from "react";
import { useNavigate } from "react-router-dom";

const AdminHeader = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/");
  };

  return (
    <div className="admin-header">

      <h2>Dashboard</h2>

      <button onClick={handleLogout}>Logout</button>

    </div>
  );
};

export default AdminHeader;